import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    personalkostensatzOhneLohnnebenkosten: 0, // euro stundenlohn
    personalkostensatz: 0, // euro stundenlohn
    personalkostenquote: 0, // percent
    umsatzProGast: 0, // euro
    gastVerweildauer: 0, // minutes
    salesByWeekdayAndHour: new Map<string,Map<string,number>>(),
    groups: ["Service", "Bar", "Küche", "Spüle"],
    meo: new Map<string,number[]>(),
  },
  getters: {
    getSalesForWeekdayAndHours:(state:any) => (isoWeekday:string,hour:string) => {
      return state.salesByWeekdayAndHour.get(isoWeekday)?.get(hour) ?? 0;
    },
    getSalesForWeekday:(state:any) => (isoWeekday:string) => {
      return state.salesByWeekdayAndHour.get(isoWeekday);
    },
    getMaxSales:(state:any) => () => {
      let maxSales = 0;
      state.salesByWeekdayAndHour.forEach((salesByHour:Map<string,number>) => {
        salesByHour.forEach((sales:number) => {
          maxSales = Math.max(maxSales,sales);
        });
      });;
      return maxSales;
    },
    getMeoValueForGroupAndRowId:(state:any) => (group:string,rowId:number|string) => {
      if (state.meo.get(group) && state.meo.get(group).length > parseInt(rowId.toString(),10)) {
        return state.meo.get(group)[rowId] ?? 0;
      }
      return 0;
    },
  },
  mutations: {
    setSalesForWeekdayAndHours:(state:any,payload:{isoWeekday:string,hour:string,salesInEuro:number})=> {
      const salesByWeekday = state.salesByWeekdayAndHour.get(payload.isoWeekday) ?? new Map<string,number>();
      salesByWeekday.set(payload.hour,payload.salesInEuro);
      state.salesByWeekdayAndHour.set(payload.isoWeekday,salesByWeekday)
    },
    updatePersonalkostenquote:(state:any,value:number)=> {
      state.personalkostenquote = value;
    },
    updatePersonalkostensatz:(state:any,value:number)=> {
      state.personalkostensatz = value;
    },
    updatePersonalkostensatzOhneLohnnebenkosten:(state:any,value:number)=> {
      state.personalkostensatzOhneLohnnebenkosten = value;
    },
    updateUmsatzProGast:(state:any,value:number)=> {
      state.umsatzProGast = value;
    },
    updateGastVerweildauer:(state:any,value:number)=> {
      state.gastVerweildauer = value;
    },
    removeGroup:(state:any,group:string)=> {
      state.groups = state.groups.filter((o:string) => o !== group);;
    },
    addGroup:(state:any,group:string)=> {
      if(!state.groups.includes(group)) {
        state.groups.push(group);
      }
    },
    updateMeoValueForGroupAndRowId:(state:any,payload:{group:string,rowId:number|string,value:number}) => {
      if (!state.meo.get(payload.group)) {
        state.meo.set(payload.group,[]);
      }
      state.meo.get(payload.group)[payload.rowId] = payload.value;
      return 0;
    },
  },
  actions: {},
  modules: {}
});
